/**;
 * @fileoverview Object for Entry.
 */
'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _domUtils = _interopRequireDefault(require("../../src/util/domUtils"));
var _GEHelper = require("../graphicEngine/GEHelper");
var _findIndex = require('lodash/findIndex');

/**
 * Class for entry object.
 * @param {?object model} model for object
 * @constructor
 */
Entry.EntryObject = /*#__PURE__*/function () {
  function _class(model) {
    var _this = this;
    (0, _classCallCheck2["default"])(this, _class);
    (0, _defineProperty2["default"])(this, "setDisabled", function () {
      if (_this.nameView_) {
        _this.nameView_.disabled = true;
      }
      if (_this.rotateInput_) {
        _this.rotateInput_.disabled = true;
      }
      if (_this.directionInput_) {
        _this.directionInput_.disabled = true;
      }
      if (_this.coordinateView_) {
        _this.coordinateView_.sizeInput_.disabled = true;
        _this.coordinateView_.xInput_.disabled = true;
        _this.coordinateView_.yInput_.disabled = true;
      }
    });
    (0, _defineProperty2["default"])(this, "setEnabled", function () {
      if (_this.nameView_) {
        _this.nameView_.disabled = false;
      }
      if (_this.rotateInput_) {
        _this.rotateInput_.disabled = false;
      }
      if (_this.directionInput_) {
        _this.directionInput_.disabled = false;
      }
      if (_this.coordinateView_) {
        _this.coordinateView_.sizeInput_.disabled = false;
        _this.coordinateView_.xInput_.disabled = false;
        _this.coordinateView_.yInput_.disabled = false;
      }
    });
    if (model) {
      var _this$sounds;
      this.id = model.id;
      this.name = model.name || model.sprite.name;
      this.text = model.text || this.name;
      this.objectType = model.objectType || 'sprite';
      this.script = new Entry.Code(model.script || [], this);
      this.pictures = Entry.Utils.copy(model.sprite.pictures || []);
      this.sounds = Entry.Utils.copy(model.sprite.sounds || []);
      this._setFocused = Entry.Utils.setFocused;
      this._setBlurredTimer = Entry.Utils.setBlurredTimer;
      this.editObjectValueWhenEnterPress = Entry.Utils.whenEnter(function () {
        _this.editObjectValues(false);
      });
      this.sounds.forEach(function (s) {
        if (!s.id) {
          s.id = Entry.generateHash();
        }
        Entry.initSound(s);
      });
      this.lock = model.lock ? model.lock : false;
      this.isEditing = false;
      if (this.objectType === 'sprite') {
        this.selectedPicture = !model.selectedPictureId ? this.pictures[0] : this.getPicture(model.selectedPictureId);
      }
      if ((_this$sounds = this.sounds) !== null && _this$sounds !== void 0 && _this$sounds.length) {
        this.selectedSound = this.sounds[0];
      }
      this.scene = Entry.scene.getSceneById(model.scene) || Entry.scene.selectedScene;
      this.setRotateMethod(model.rotateMethod);

      //entity
      this.entity = new Entry.EntityObject(this);
      this.entity.injectModel(this.selectedPicture ? this.selectedPicture : null, model.entity ? model.entity : this.initEntity(model));
      this.clonedEntities = [];
      Entry.stage.loadObject(this);
      var pictures = this.pictures;
      for (var i in pictures) {
        var picture = pictures[i];
        picture.objectId = this.id;
        if (!picture.id) {
          picture.id = Entry.generateHash();
        }
        _GEHelper.GEHelper.resManager.reqResource(null, this.scene.id, picture);
      }
      Entry.requestUpdate = true;
    }
    this._isContextMenuEnabled = true;
    this.isFolded = false;
  }

  /**
   * View generator for workspace or others.
   * Entry.type === 'phone' 관련 뷰 삭제
   * @return {!Element}
   */
  return (0, _createClass2["default"])(_class, [{
    key: "generateView",
    value: function generateView() {
      return this.generateWorkspaceView();
    }

    /**
     * Object name setter
     * @param {!string} name
     */
  }, {
    key: "setName",
    value: function setName(name) {
      Entry.assert(typeof name === 'string', 'object name must be string');
      this.name = name;
      if (this.nameView_) {
        this.nameView_.value = name;
      }
    }
  }, {
    key: "getName",
    value: function getName() {
      return this.name;
    }

    /**
     * Object text setter
     * @param {!string} name
     */
  }, {
    key: "setText",
    value: function setText(text) {
      Entry.assert(typeof text === 'string', 'object text must be string');
      this.text = text;
    }

    /**
     * Object script setter
     * @param {!xml script} script
     */
  }, {
    key: "setScript",
    value: function setScript(script) {
      this.script = script;
    }

    /**
     * Object script getter
     * @return {!xml script} script
     */
  }, {
    key: "getScriptText",
    value: function getScriptText() {
      return this.script.stringify();
    }

    /**
     * Initialize entity model if not exist
     * @param {!object model} model for object
     * @return {entity model}
     */
  }, {
    key: "initEntity",
    value: function initEntity(model) {
      var json = {};
      json.rotation = json.x = json.y = 0;
      json.direction = 90;
      if (this.objectType == 'sprite') {
        var dimension = model.sprite.pictures[0].dimension;
        json.regX = dimension.width / 2;
        json.regY = dimension.height / 2;
        var scale;
        var mainCategory = model.sprite.category.main;
        if (mainCategory == 'background' || mainCategory == 'new') {
          scale = Math.max(270 / dimension.height, 480 / dimension.width);
        } else if (mainCategory == 'new') {
          scale = 1;
        } else {
          scale = 200 / (dimension.width + dimension.height);
        }
        json.scaleX = json.scaleY = scale;
        json.width = dimension.width;
        json.height = dimension.height;
      } else if (this.objectType == 'textBox') {
        json.regX = 25;
        json.regY = 12;
        json.scaleX = json.scaleY = 1.5;
        json.width = 50;
        json.height = 24;
        json.text = model.text;
        if (model.options) {
          var options = model.options;
          var fontStyle = '';
          var _options$fontSize = options.fontSize,
            fontSize = _options$fontSize === void 0 ? 20 : _options$fontSize,
            _options$textAlign = options.textAlign,
            textAlign = _options$textAlign === void 0 ? 0 : _options$textAlign,
            _options$scaleX = options.scaleX,
            scaleX = _options$scaleX === void 0 ? 1.5 : _options$scaleX,
            regX = options.regX,
            regY = options.regY,
            width = options.width,
            height = options.height;
          if (options.bold) {
            fontStyle += 'bold ';
          }
          if (options.italic) {
            fontStyle += 'italic ';
          }
          json.underLine = options.underLine;
          json.strike = options.strike;
          if (typeof options.font === 'string') {
            json.font = options.font;
          } else {
            json.font = "".concat(fontStyle).concat(fontSize, "px ").concat(options.font.family);
          }
          json.colour = options.colour;
          json.bgColor = options.bgColor || options.background;
          json.lineBreak = options.lineBreak;
          json.textAlign = textAlign;
          json.scaleX = json.scaleY = scaleX;
          if (options.lineBreak) {
            json.width = width || 256;
            json.height = height || json.width * 0.5625;
            json.regX = regX || json.width / 2;
            json.regY = regY || json.height / 2;
          }
        } else {
          json.underLine = false;
          json.strike = false;
          json.font = '20px Nanum Gothic';
          json.colour = '#000000';
          json.bgColor = '#ffffff';
        }
      }
      return json;
    }

    /**
     * Update thumbnail view;
     */
  }, {
    key: "updateThumbnailView",
    value: function updateThumbnailView() {
      var thumb = this.thumbnailView_;
      var picture = this.entity.picture;
      var objectType = this.objectType;
      this.thumbUrl = '';
      if (objectType === 'sprite') {
        if (picture.thumbUrl || picture.fileurl) {
          this.thumbUrl = picture.thumbUrl || picture.fileurl;
        } else {
          var fileName = picture.filename;
          this.thumbUrl = "".concat(Entry.defaultPath, "/uploads/").concat(fileName.substring(0, 2), "/").concat(fileName.substring(2, 4), "/thumb/").concat(fileName, ".png");
        }
        thumb.style.backgroundImage = "url(".concat(encodeURI(this.thumbUrl), ")");
      } else if (objectType === 'textBox') {
        var _ref = Lang || {},
          type = _ref.type;
        var filename = type === 'ko' ? 'text_icon_ko.svg' : 'text_icon.svg';
        this.thumbUrl = "".concat(Entry.mediaFilePath).concat(filename);
        $(thumb).addClass('entryObjectTextBox');
      }
    }

    /**
     * Update coordinate view;
     */
  }, {
    key: "updateCoordinateView",
    value: function updateCoordinateView(isForced) {
      if (!this.isSelected() && !isForced) {
        return;
      }
      var view = this.coordinateView_;
      if (view && view.xInput_ && view.yInput_) {
        var originX = view.xInput_.value;
        var originY = view.yInput_.value;
        var size = view.sizeInput_.value;
        var entity = this.entity;
        var newX = entity.getX(1);
        var newY = entity.getY(1);
        var newSize = entity.getSize(1);
        if (originX != newX) {
          view.xInput_.value = newX;
        }
        if (originY != newY) {
          view.yInput_.value = newY;
        }
        if (size != newSize) {
          view.sizeInput_.value = newSize;
        }
      }
    }

    /**
     * Update rotation view;
     */
  }, {
    key: "updateRotationView",
    value: function updateRotationView(isForced) {
      if ((!this.isSelected() || !this.view_) && !isForced) {
        return;
      }
      var rotateMethod = this.getRotateMethod();
      var entity = this.entity;
      var className = 'entryRemove';
      if (rotateMethod === 'free') {
        this.rotateWrapper_.removeClass(className);
        this.rotateInput_.value = "".concat(entity.getRotation(1));
        this.directionInput_.value = "".concat(entity.getDirection(1));
      } else {
        this.rotateWrapper_.addClass(className);
        this.directionInput_.value = "".concat(entity.getDirection(1));
      }
    }

    /**
     * Add picture object by picture model.
     * @param {picture model} picture
     */
  }, {
    key: "addPicture",
    value: function addPicture(picture, index) {
      picture.objectId = this.id;
      if (typeof index === 'undefined') {
        this.pictures.push(picture);
      } else {
        this.pictures.splice(index, 0, picture);
      }
      Entry.playground.injectPicture(this);
    }

    /**
     * Remove picture object.
     * @param {string} pictureId
     * @return {boolean} return true if success
     */
  }, {
    key: "removePicture",
    value: function removePicture(pictureId) {
      var pictures = this.pictures;
      if (pictures.length < 2) {
        return;
      }
      var playground = Entry.playground;
      var picture = this.getPicture(pictureId);
      pictures.splice(pictures.indexOf(picture), 1);
      if (picture === this.selectedPicture) {
        playground.selectPicture(pictures[0], true);
      }
      _GEHelper.GEHelper.resManager.imageRemoved('EntityObject::removePicture');
      playground.injectPicture(this);
      playground.reloadPlayground();
    }

    /**
     * Get picture object by Id.
     * @param {?string} pictureId
     * @return {picture object}
     */
  }, {
    key: "getPicture",
    value: function getPicture(value) {
      //priority
      //1. pictureId
      //2. pictureName
      //3. index
      if (!value) {
        return this.selectedPicture;
      }
      value = "".concat(value).trim();
      var pictures = this.pictures;
      var len = pictures.length;
      for (var i = 0; i < len; i++) {
        if (pictures[i].id == value) {
          return pictures[i];
        }
      }
      for (var _i = 0; _i < len; _i++) {
        if (pictures[_i].name == value) {
          return pictures[_i];
        }
      }
      var checker = Entry.parseNumber(value);
      if (!(checker === false && typeof checker === 'boolean') && len >= checker && checker > 0) {
        return pictures[checker - 1];
      }
      return null;
    }
  }, {
    key: "getPictureIndex",
    value: function getPictureIndex(value) {
      return this.pictures.indexOf(this.getPicture(value));
    }

    /**
     * Get previous picture object by Id.
     * @param {?string} pictureId
     * @return {picture object}
     */
  }, {
    key: "getPrevPicture",
    value: function getPrevPicture(pictureId) {
      var pictures = this.pictures;
      var idx = this.getPictureIndex(pictureId);
      return pictures[idx === 0 ? pictures.length - 1 : --idx];
    }

    /**
     * Get next picture object by Id.
     * @param {?string} pictureId
     * @return {picture object}
     */
  }, {
    key: "getNextPicture",
    value: function getNextPicture(pictureId) {
      var pictures = this.pictures;
      var len = pictures.length;
      var idx = this.getPictureIndex(pictureId);
      return pictures[idx == len - 1 ? 0 : ++idx];
    }

    /**
     * Select picture object by Id.
     * @param {!string} pictureId
     * @return {picture object}
     */
  }, {
    key: "selectPicture",
    value: function selectPicture(pictureId) {
      var picture = this.getPicture(pictureId);
      if (!picture) {
        throw new Error("No picture with pictureId : ".concat(pictureId));
      }
      this.selectedPicture = picture;
      this.entity.setImage(picture);
      this.updateThumbnailView();
    }
  }, {
    key: "selectSound",
    value: function selectSound(soundId) {
      var sound = this.getSound(soundId);
      if (!sound) {
        throw new Error("No sound with soundId : ".concat(soundId));
      }
      this.selectedSound = sound;
    }

    /**
     * Add sound to object
     * @param {sound model} sound
     */
  }, {
    key: "addSound",
    value: function addSound(sound, index) {
      if (!sound.id) {
        sound.id = Entry.generateHash();
      }
      Entry.initSound(sound, index);
      if (typeof index === 'undefined') {
        this.sounds.push(sound);
      } else {
        this.sounds.splice(index, 0, sound);
      }
      Entry.playground.injectSound(this);
    }

    /**
     * Remove sound object.
     * @param {string} soundId
     */
  }, {
    key: "removeSound",
    value: function removeSound(soundId) {
      var playground = Entry.playground;
      var sound = this.getSound(soundId);
      var index = _findIndex(this.sounds, function (sound) {
        return sound.id === soundId;
      });
      this.sounds.splice(index, 1);
      if (sound === this.selectedSound) {
        var _this$sounds2;
        if ((_this$sounds2 = this.sounds) !== null && _this$sounds2 !== void 0 && _this$sounds2.length) {
          playground.selectSound(this.sounds[0], true);
        } else {
          this.selectedSound = undefined;
        }
      }
      Entry.playground.injectSound();
      Entry.playground.reloadPlayground();
    }

    /**
     * rotate method getter
     * @return {string}
     */
  }, {
    key: "getRotateMethod",
    value: function getRotateMethod() {
      if (!this.rotateMethod) {
        this.rotateMethod = 'free';
      }
      return this.rotateMethod;
    }

    /**
     * rotate method setter
     * @param {string} rotateMethod
     */
  }, {
    key: "setRotateMethod",
    value: function setRotateMethod() {
      var rotateMethod = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'free';
      /** @type {string} */
      this.rotateMethod = rotateMethod;
      this.updateRotateMethodView();
      var stage = Entry.stage;
      var entity = stage.selectedObject && stage.selectedObject.entity;
      if (entity) {
        stage.updateObject();
        stage.updateHandle();
      }
    }
  }, {
    key: "initRotateValue",
    value: function initRotateValue(rotateMethod) {
      if (this.rotateMethod === rotateMethod) {
        return;
      }
      var entity = this.entity;
      var direction = entity.direction;
      entity.direction = direction !== undefined ? direction : 90.0;
      entity.rotation = 0.0;
      entity.flip = false;
    }
  }, {
    key: "updateRotateMethodView",
    value: function updateRotateMethodView() {
      if (!this.rotateModeAView_) {
        return;
      }
      var SELECTED = 'selected';
      this.rotateModeAView_.removeClass(SELECTED);
      this.rotateModeBView_.removeClass(SELECTED);
      this.rotateModeCView_.removeClass(SELECTED);
      var rotateMethod = this.rotateMethod;
      if (rotateMethod === 'free') {
        this.rotateModeAView_.addClass(SELECTED);
      } else if (rotateMethod === 'vertical') {
        this.rotateModeBView_.addClass(SELECTED);
      } else {
        this.rotateModeCView_.addClass(SELECTED);
      }
      this.updateRotationView();
    }

    /**
     * Add clone entity for clone block
     * If parameter given, this clone the parameter entity itself.
     * Otherwise, this clone this object's entity.
     * @param {?Entry.EntryObject} object
     * @param {?Entry.EntityObject} entity
     * @param {?xml block} script
     */
  }, {
    key: "addCloneEntity",
    value: function addCloneEntity(object, entity, script) {
      if (this.clonedEntities.length > Entry.maxCloneLimit) {
        return;
      }
      var clonedEntity = new Entry.EntityObject(this);
      clonedEntity.isClone = true;
      entity = entity || this.entity;
      clonedEntity.injectModel(entity.picture || null, entity.toJSON());
      clonedEntity.snapshot_ = entity.snapshot_;
      if (entity.effect) {
        clonedEntity.effect = _.clone(entity.effect);
        clonedEntity.applyFilter();
      }
      Entry.engine.raiseEventOnEntity(clonedEntity, [clonedEntity, 'when_clone_start']);
      clonedEntity.isStarted = true;
      this.addCloneVariables(this, clonedEntity, entity ? entity.variables : null, entity ? entity.lists : null);
      this.clonedEntities.push(clonedEntity);
      var targetIndex = Entry.stage.selectedObjectContainer.getChildIndex(entity.object);
      var offsetCount = (entity.shapes.length ? 1 : 0) + (entity.paintShapes.length ? 1 : 0);
      targetIndex -= offsetCount + entity.stamps.length;
      Entry.stage.loadEntity(clonedEntity, targetIndex);
      if (entity.brush) {
        Entry.setCloneBrush(clonedEntity, entity.brush);
      }
    }

    /**
     * return true when object is selected
     * @return {Boolean}
     */
  }, {
    key: "isSelected",
    value: function isSelected() {
      return this.isSelected_;
    }

    /**
     * convert this object's data to JSON.
     * @return {JSON}
     */
  }, {
    key: "toJSON",
    value: function toJSON(isClone) {
      var json = {};
      json.id = isClone ? Entry.generateHash() : this.id;
      json.name = this.name;
      json.script = this.getScriptText();
      json.objectType = this.objectType;
      json.rotateMethod = this.getRotateMethod();
      json.scene = this.scene.id;
      json.sprite = {
        pictures: Entry.getPicturesJSON(this.pictures, isClone),
        sounds: Entry.getSoundsJSON(this.sounds, isClone)
      };
      if (this.objectType === 'textBox') {
        json.text = this.text;
      } else {
        json.selectedPictureId = json.sprite.pictures[this.pictures.indexOf(this.selectedPicture)].id;
      }
      json.lock = this.lock;
      json.entity = this.entity.toJSON();
      return json;
    }

    /**
     * destroy this object
     */
  }, {
    key: "destroy",
    value: function destroy() {
      this.entity && this.entity.destroy();
      Entry.removeElement(this.view_);
    }

    /**
     * Get sound object by Id.
     * @param {?string} soundId
     * @return {sound object}
     */
  }, {
    key: "getSound",
    value: function getSound(value) {
      //priority
      //1. soundId
      //2. soundName
      //3. index
      if (!value) {
        return this.selectedSound;
      }
      value = String(value).trim();
      var sounds = this.sounds;
      var len = sounds.length;
      for (var i = 0; i < len; i++) {
        if (sounds[i].id == value) {
          return sounds[i];
        }
      }
      for (var _i2 = 0; _i2 < len; _i2++) {
        if (sounds[_i2].name == value) {
          return sounds[_i2];
        }
      }
      var checker = Entry.parseNumber(value);
      if (!(checker === false && typeof checker === 'boolean') && len >= checker && checker > 0) {
        return sounds[checker - 1];
      }
      return null;
    }
  }, {
    key: "addCloneVariables",
    value: function addCloneVariables(_ref2, entity, variables, lists) {
      var id = _ref2.id;
      var _whereFunc = _.partial(_.filter, _, {
        object_: id
      });
      var _cloneFunc = function _cloneFunc(v) {
        return v.clone();
      };
      var _Entry$variableContai = Entry.variableContainer,
        variables_ = _Entry$variableContai.variables_,
        lists_ = _Entry$variableContai.lists_;
      entity.variables = (variables || _whereFunc(variables_)).map(_cloneFunc);
      entity.lists = (lists || _whereFunc(lists_)).map(_cloneFunc);
    }
  }, {
    key: "getLock",
    value: function getLock() {
      return this.lock;
    }
  }, {
    key: "setLock",
    value: function setLock(bool) {
      this.lock = bool;
      Entry.stage.updateObject();
      return bool;
    }
  }, {
    key: "updateInputViews",
    value: function updateInputViews(isLocked) {
      isLocked = isLocked || this.getLock();
      var inputs = [this.nameView_, this.coordinateView_.xInput_, this.coordinateView_.yInput_, this.rotateInput_, this.directionInput_, this.coordinateView_.sizeInput_];
      if (isLocked) {
        inputs.forEach(function (input) {
          input.setAttribute('disabled', 'disabled');
        });
      } else {
        inputs.forEach(function (input) {
          input.removeAttribute('disabled');
        });
      }
      this.isEditing = !isLocked;
    }
  }, {
    key: "editObjectValues",
    value: function editObjectValues(activate) {
      var inputs = [this.nameView_, this.coordinateView_.xInput_, this.coordinateView_.yInput_, this.rotateInput_, this.directionInput_, this.coordinateView_.sizeInput_];
      if (activate && !this.isEditing) {
        this.isEditing = true;
      } else {
        inputs.forEach(function (input) {
          input.blur(true);
        });
        this.isEditing = false;
      }
    }

    /**
     *  get only clonedEntities among clonedEntities except for stamp entity
     *  @return {Array<clone Entity> } entities
     */
  }, {
    key: "getClonedEntities",
    value: function getClonedEntities() {
      return this.clonedEntities.concat();
    }
  }, {
    key: "clearExecutor",
    value: function clearExecutor() {
      this.script.clearExecutors();
      var clonedEntities = this.clonedEntities;
      for (var j = clonedEntities.length - 1; j >= 0; j--) {
        clonedEntities[j].removeClone(true);
      }
      this.entity.removeStamps();
    }
  }, {
    key: "_rightClick",
    value: function _rightClick(e) {
      var _this2 = this;
      if (!this.isContextMenuEnabled()) {
        return;
      }
      e.stopPropagation();
      var object = this;
      var container = Entry.container;
      var objects = container._getSortableObjectList();
      var objectIndex = objects.findIndex(function (item) {
        return item.key == _this2.id;
      });
      var contextMenus = [{
        text: Lang.Workspace.context_duplicate,
        enable: !Entry.engine.isState('run'),
        callback: function callback() {
          container.addCloneObject(object);
        }
      }, {
        text: Lang.Workspace.copy_file,
        callback: function callback() {
          container.setCopiedObject(object);
        }
      }, {
        text: Lang.Blocks.Paste_blocks,
        enable: !Entry.engine.isState('run') && !!container.copiedObject,
        callback: function callback() {
          if (container.copiedObject) {
            container.addCloneObject(container.copiedObject);
          } else {
            Entry.toast.alert(Lang.Workspace.add_object_alert, Lang.Workspace.object_not_found_for_paste);
          }
        }
      }, {
        text: Lang.Workspace.context_remove,
        enable: !Entry.engine.isState('run') && !this.getLock(),
        callback: function callback() {
          if (_this2.getLock()) {
            return true;
          }
          Entry.dispatchEvent('removeObject', object);
          var id = object.id;
          Entry["do"]('removeObject', id);
          Entry.Utils.forceStopSounds();
        }
      }, {
        text: Lang.Workspace.bring_forward,
        enable: objectIndex > 0,
        callback: function callback() {
          Entry["do"]('objectReorder', objectIndex - 1, objectIndex);
        }
      }, {
        text: Lang.Workspace.send_backward,
        enable: objectIndex < objects.length - 1,
        callback: function callback() {
          Entry["do"]('objectReorder', objectIndex + 1, objectIndex);
        }
      }];
      if (!Entry.backpackDisable) {
        contextMenus.push({
          text: Lang.Blocks.add_my_storage,
          enable: !Entry.engine.isState('run') && !!window.user,
          callback: function callback() {
            _this2.addStorage();
          }
        });
      }
      if (Entry.exportObjectEnable) {
        contextMenus.push({
          text: Lang.Blocks.export_object,
          callback: function callback() {
            Entry.dispatchEvent('exportObject', object);
          }
        });
      }
      var _Entry$Utils$convertM = Entry.Utils.convertMouseEvent(e),
        x = _Entry$Utils$convertM.clientX,
        y = _Entry$Utils$convertM.clientY;
      Entry.ContextMenu.show(contextMenus, 'workspace-contextmenu', {
        x: x,
        y: y
      });
    }
  }, {
    key: "addStorage",
    value: function addStorage() {
      Entry.dispatchEvent('addStorage', {
        type: 'object',
        data: this
      });
    }
  }, {
    key: "enableContextMenu",
    value: function enableContextMenu() {
      this._isContextMenuEnabled = true;
    }
  }, {
    key: "disableContextMenu",
    value: function disableContextMenu() {
      this._isContextMenuEnabled = false;
    }
  }, {
    key: "isContextMenuEnabled",
    value: function isContextMenuEnabled() {
      return this._isContextMenuEnabled && Entry.objectEditable;
    }
  }, {
    key: "toggleEditObject",
    value: function toggleEditObject() {
      if (this.isEditing || Entry.engine.isState('run')) {
        return;
      }
      this.editObjectValues(true);
      if (Entry.playground.object !== this) {
        Entry.container.selectObject(this.id);
      }
    }
  }, {
    key: "getDom",
    value: function getDom(query) {
      if (_.isEmpty(query)) {
        return this.view_;
      }
      switch (query.shift()) {
        case 'editButton':
          return this.editView_;
        case 'nameInput':
          return this.nameView_;
        case 'removeButton':
          return this.deleteView_;
        case 'xInput':
          return this.coordinateView_.xInput_;
        case 'yInput':
          return this.coordinateView_.yInput_;
        case 'sizeInput':
          return this.coordinateView_.sizeInput_;
        case 'directionInput':
          return this.directionInput_;
        case 'rotationInput':
          return this.rotateInput_;
        case 'rotationMethod':
          return this._getRotateView(query.shift());
      }
    }
  }, {
    key: "setInputBlurred",
    value: function setInputBlurred() {
      for (var _len = arguments.length, target = new Array(_len), _key = 0; _key < _len; _key++) {
        target[_key] = arguments[_key];
      }
      target = this.getDom(target);
      if (!target) {
        return;
      }
      target._focused = false;
    }
  }, {
    key: "generateWorkspaceView",
    value: function generateWorkspaceView() {
      var exceptionsForMouseDown = [];
      var that = this;
      var objectId = this.id;
      this.view_ = this.createObjectView(objectId, exceptionsForMouseDown); // container
      if (!Entry.objectEditable) {
        this.view_.addClass('entryDisabled');
      }
      this.view_.appendChild(this.createObjectInfoView()); // visible, lock

      var thumbnailView = this.createThumbnailView(objectId); // thumbnail
      this.thumbnailView_ = thumbnailView;
      this.view_.appendChild(thumbnailView);
      this.view_.appendChild(this.createWrapperView()); // name space

      var informationView = this.createInformationView();
      this.informationView_ = informationView;
      this.view_.appendChild(informationView);
      var deleteView = this.createDeleteView(exceptionsForMouseDown, that); // delete
      this.deleteView_ = deleteView;
      this.view_.appendChild(deleteView);
      var rotationWrapperView = this.createRotationWrapperView();
      this.view_.appendChild(rotationWrapperView);
      this.updateThumbnailView();
      this.updateRotateMethodView();
      this.updateInputViews();
      this.updateCoordinateView(true);
      this.updateRotationView(true);
      if (!Entry.objectEditable) {
        this.setDisabled();
      } else {
        Entry.addEventListener('run', this.setDisabled);
        Entry.addEventListener('dispatchEventDidToggleStop', this.setEnabled);
      }
      return this.view_;
    }
  }, {
    key: "createRotationMethodWrapperView",
    value: function createRotationMethodWrapperView() {
      var _this3 = this;
      var rotationMethodWrapper = Entry.createElement('div').addClass('rotationMethodWrapper');
      var rotateMethodLabelView = Entry.createElement('span').addClass('entryObjectRotateMethodLabelWorkspace');
      rotationMethodWrapper.appendChild(rotateMethodLabelView);
      rotateMethodLabelView.textContent = "".concat(Lang.Workspace.rotate_method);
      var rotateModeAView = Entry.createElement('span').addClass('entryObjectRotateModeWorkspace entryObjectRotateModeAWorkspace');
      this.rotateModeAView_ = rotateModeAView;
      rotationMethodWrapper.appendChild(rotateModeAView);
      rotationMethodWrapper.appendChild(rotateModeAView);
      if (Entry.objectEditable) {
        rotateModeAView.bindOnClick(this._whenRotateEditable(function () {
          Entry["do"]('objectUpdateRotateMethod', _this3.id, 'free');
        }, this));
      }
      var rotateModeBView = Entry.createElement('span').addClass('entryObjectRotateModeWorkspace entryObjectRotateModeBWorkspace');
      this.rotateModeBView_ = rotateModeBView;
      rotationMethodWrapper.appendChild(rotateModeBView);
      if (Entry.objectEditable) {
        rotateModeBView.bindOnClick(this._whenRotateEditable(function () {
          Entry["do"]('objectUpdateRotateMethod', _this3.id, 'vertical');
        }, this));
      }
      var rotateModeCView = Entry.createElement('span').addClass('entryObjectRotateModeWorkspace entryObjectRotateModeCWorkspace');
      this.rotateModeCView_ = rotateModeCView;
      rotationMethodWrapper.appendChild(rotateModeCView);
      if (Entry.objectEditable) {
        rotateModeCView.bindOnClick(this._whenRotateEditable(function () {
          Entry["do"]('objectUpdateRotateMethod', _this3.id, 'none');
        }, this));
      }
      return rotationMethodWrapper;
    }
  }, {
    key: "createRotateLabelWrapperView",
    value: function createRotateLabelWrapperView() {
      var _this4 = this;
      var rotateLabelWrapperView = Entry.createElement('div').addClass('entryObjectRotateLabelWrapperWorkspace');
      var rotateWrapper = Entry.createElement('span').addClass('entryObjectRotateWorkspaceWrapper');
      var rotateSpan = Entry.createElement('span').addClass('entryObjectRotateSpanWorkspace');
      rotateSpan.textContent = "".concat(Lang.Workspace.rotation);
      var RotateDegCoordi = Entry.createElement('span').addClass('entryObjectCoordinateSpanWorkspace degree');
      var rotateInput = Entry.createElement('input').addClass('entryObjectRotateInputWorkspace');
      rotateInput.setAttribute('type', 'text');
      rotateInput.onkeypress = this.editObjectValueWhenEnterPress;
      rotateInput.onfocus = this._setFocused;
      rotateInput.onblur = this._setBlurredTimer(function () {
        var object = Entry.container.getObject(_this4.id);
        if (!object) {
          return;
        }
        var value = rotateInput.value;
        var idx = value.indexOf('˚');
        if (~idx) {
          value = value.substring(0, idx);
        }
        Entry["do"]('objectUpdateRotationValue', _this4.id, Entry.Utils.isNumber(value) ? value : _this4.entity.getRotation());
      });
      this.rotateWrapper_ = rotateWrapper;
      this.rotateSpan_ = rotateSpan;
      this.rotateInput_ = rotateInput;
      var directionWrapper = Entry.createElement('span').addClass('entryObjectDirectionWorkspaceWrapper');
      var directionSpan = Entry.createElement('span').addClass('entryObjectDirectionSpanWorkspace');
      directionSpan.textContent = "".concat(Lang.Workspace.direction);
      var DirectionDegCoordi = Entry.createElement('span').addClass('entryObjectCoordinateSpanWorkspace degree');
      var directionInput = Entry.createElement('input').addClass('entryObjectDirectionInputWorkspace');
      directionInput.setAttribute('type', 'text');
      directionInput.onkeypress = this.editObjectValueWhenEnterPress;
      directionInput.onfocus = this._setFocused;
      directionInput.onblur = this._setBlurredTimer(function () {
        var object = Entry.container.getObject(_this4.id);
        if (!object) {
          return;
        }
        var value = directionInput.value;
        var idx = value.indexOf('˚');
        if (~idx) {
          value = value.substring(0, idx);
        }
        Entry["do"]('objectUpdateDirectionValue', _this4.id, Entry.Utils.isNumber(value) ? value : _this4.entity.getDirection());
      });
      this.directionInput_ = directionInput;
      rotateWrapper.appendChild(rotateSpan);
      rotateWrapper.appendChild(rotateInput);
      rotateWrapper.appendChild(RotateDegCoordi);
      directionWrapper.appendChild(directionSpan);
      directionWrapper.appendChild(directionInput);
      directionWrapper.appendChild(DirectionDegCoordi);
      rotateLabelWrapperView.appendChild(rotateWrapper);
      rotateLabelWrapperView.appendChild(directionWrapper);
      rotateLabelWrapperView.rotateInput_ = rotateInput;
      rotateLabelWrapperView.directionInput_ = directionInput;
      return rotateLabelWrapperView;
    }
  }, {
    key: "createCoordinationView",
    value: function createCoordinationView() {
      var _this5 = this;
      var coordinationView = Entry.createElement('div').addClass('entryObjectCoordinateWorkspace');
      var xCoordiWrapper = Entry.createElement('span').addClass('entryObjectCoordinateWorkspaceWrapper');
      var xCoordi = Entry.createElement('span').addClass('entryObjectCoordinateSpanWorkspace');
      xCoordi.textContent = 'X';
      var xInput = Entry.createElement('input').addClass('entryObjectCoordinateInputWorkspace');
      xInput.setAttribute('type', 'text');
      xInput.onkeypress = this.editObjectValueWhenEnterPress;
      xInput.onfocus = this._setFocused;
      xInput.onblur = this._setBlurredTimer(function () {
        var object = Entry.container.getObject(_this5.id);
        if (!object) {
          return;
        }
        var value = xInput.value;
        Entry["do"]('objectUpdatePosX', _this5.id, Entry.Utils.isNumber(value) ? value : _this5.entity.getX());
      });
      var yCoordiWrapper = Entry.createElement('span').addClass('entryObjectCoordinateWorkspaceWrapper');
      var yCoordi = Entry.createElement('span').addClass('entryObjectCoordinateSpanWorkspace');
      yCoordi.textContent = 'Y';
      var PerCoordi = Entry.createElement('span').addClass('entryObjectCoordinateSpanWorkspace');
      PerCoordi.textContent = '%';
      var yInput = Entry.createElement('input').addClass('entryObjectCoordinateInputWorkspace entryObjectCoordinateInputWorkspace_right');
      yInput.setAttribute('type', 'text');
      yInput.onkeypress = this.editObjectValueWhenEnterPress;
      yInput.onfocus = this._setFocused;
      yInput.onblur = this._setBlurredTimer(function () {
        var object = Entry.container.getObject(_this5.id);
        if (!object) {
          return;
        }
        var value = yInput.value;
        Entry["do"]('objectUpdatePosY', _this5.id, Entry.Utils.isNumber(value) ? value : _this5.entity.getY());
      });
      var sizeWrapper = Entry.createElement('span').addClass('entryObjectCoordinateSizeWrapper');
      var sizeSpan = Entry.createElement('span').addClass('entryObjectCoordinateSizeWorkspace');
      sizeSpan.textContent = "".concat(Lang.Workspace.Size);
      var sizeInput = Entry.createElement('input').addClass('entryObjectCoordinateInputWorkspace', 'entryObjectCoordinateInputWorkspace_size');
      sizeInput.setAttribute('type', 'text');
      sizeInput.onkeypress = this.editObjectValueWhenEnterPress;
      sizeInput.onfocus = this._setFocused;
      sizeInput.onblur = this._setBlurredTimer(function () {
        var object = Entry.container.getObject(_this5.id);
        if (!object) {
          return;
        }
        var value = sizeInput.value;
        Entry["do"]('objectUpdateSize', _this5.id, Entry.Utils.isNumber(value) ? value : _this5.entity.getSize());
      });
      xCoordiWrapper.appendChild(xCoordi);
      xCoordiWrapper.appendChild(xInput);
      yCoordiWrapper.appendChild(yCoordi);
      yCoordiWrapper.appendChild(yInput);
      sizeWrapper.appendChild(sizeSpan);
      sizeWrapper.appendChild(sizeInput);
      sizeWrapper.appendChild(PerCoordi);
      coordinationView.appendChild(xCoordiWrapper);
      coordinationView.appendChild(yCoordiWrapper);
      coordinationView.appendChild(sizeWrapper);
      coordinationView.xInput_ = xInput;
      coordinationView.yInput_ = yInput;
      coordinationView.sizeInput_ = sizeInput;
      return coordinationView;
    }
  }, {
    key: "createRotationWrapperView",
    value: function createRotationWrapperView() {
      var rotationWrapperView = Entry.createElement('div').addClass('entryObjectRotationWrapperWorkspace');
      var coordinationView = this.createCoordinationView();
      this.coordinateView_ = coordinationView;
      rotationWrapperView.appendChild(coordinationView);
      var rotateLabelWrapperView = this.createRotateLabelWrapperView();
      rotationWrapperView.appendChild(rotateLabelWrapperView);
      var rotationMethodWrapperView = this.createRotationMethodWrapperView();
      rotateLabelWrapperView.appendChild(rotationMethodWrapperView);
      this.rotationMethodWrapper_ = rotationMethodWrapperView;
      return rotationWrapperView;
    }
  }, {
    key: "setObjectFold",
    value: function setObjectFold(isFold, isPass) {
      var $view = $(this.view_);
      if (isFold) {
        $view.addClass('fold');
      } else {
        $view.removeClass('fold');
      }
      if (!isPass) {
        this.isFolded = isFold;
      }
    }
  }, {
    key: "resetObjectFold",
    value: function resetObjectFold() {
      this.setObjectFold(this.isFolded);
    }
  }, {
    key: "createInformationView",
    value: function createInformationView() {
      var _this6 = this;
      var informationView = Entry.createElement('div').addClass('entryObjectInformationWorkspace');
      informationView.bindOnClick(function () {
        var $view = $(_this6.view_);
        if ($view.hasClass('selectedObject')) {
          _this6.setObjectFold(!_this6.isFolded);
        }
      });
      return informationView;
    }
  }, {
    key: "createDeleteView",
    value: function createDeleteView(exceptionsForMouseDown) {
      var _this7 = this;
      var deleteView = Entry.createElement('div').addClass('entryObjectDeleteWorkspace');
      exceptionsForMouseDown.push(deleteView);
      if (Entry.objectEditable && Entry.objectDeletable) {
        deleteView.bindOnClick(function (e) {
          e.stopPropagation();
          if (_this7.getLock() || Entry.engine.isState('run')) {
            return;
          }
          Entry["do"]('removeObject', _this7.id);
          Entry.removeEventListener('run', _this7.setDisabled);
          Entry.removeEventListener('dispatchEventDidToggleStop', _this7.setEnabled);
        });
      }
      return deleteView;
    }
  }, {
    key: "createNameView",
    value: function createNameView() {
      var _this8 = this;
      var nameView = Entry.createElement('input').addClass('entryObjectNameWorkspace');
      nameView.addEventListener('click', function (e) {
        if (!_.includes(_this8.view_.classList, 'selectedObject')) {
          e.preventDefault();
        }
      });
      nameView.addEventListener('contextmenu', function (e) {
        e.preventDefault();
        if (!_.includes(_this8.view_.classList, 'selectedObject')) {
          _this8._rightClick(e);
        }
      });
      nameView.addEventListener('focus', function () {
        if (!_.includes(_this8.view_.classList, 'selectedObject')) {
          nameView.blur();
        }
      });
      var onKeyPressed = Entry.Utils.whenEnter(function () {
        _this8.editObjectValues(false);
      });
      nameView.onkeypress = onKeyPressed;
      nameView.onfocus = Entry.Utils.setFocused;
      var nameViewBlur = this._setBlurredTimer(function () {
        var object = Entry.container.getObject(_this8.id);
        if (!object) {
          return;
        } else if (nameView.value.trim() === '') {
          return Entry.modal.alert(Lang.Workspace.enter_the_name).then(function () {
            nameView.focus();
          });
        }
        Entry["do"]('objectNameEdit', _this8.id, nameView.value);
      });
      Entry.attachEventListener(nameView, 'blur', nameViewBlur);
      nameView.value = this.name;
      return nameView;
    }
  }, {
    key: "createWrapperView",
    value: function createWrapperView() {
      var wrapperView = Entry.createElement('div').addClass('entryObjectWrapperWorkspace');
      var nameView = this.createNameView();
      wrapperView.appendChild(nameView);
      this.nameView_ = nameView;
      return wrapperView;
    }
  }, {
    key: "createThumbnailView",
    value: function createThumbnailView(objectId) {
      var thumbnail = Entry.createElement('div').addClass('entryObjectThumbnailWorkspace');
      _domUtils["default"].addEventListenerMultiple(thumbnail, 'mousedown touchstart', function (e) {
        Entry["do"]('containerSelectObject', objectId);
      });
      thumbnail.addEventListener('touchmove', function (e) {
        e.preventDefault();
      });
      return thumbnail;
    }
  }, {
    key: "createObjectInfoView",
    value: function createObjectInfoView() {
      var _this9 = this;
      var objectInfoView = Entry.createElement('ul').addClass('objectInfoView');
      var objectInfoVisible = Entry.createElement('li').addClass('objectInfo_visible');
      if (!this.entity.getVisible()) {
        objectInfoVisible.addClass('objectInfo_unvisible');
      }
      var objectInfoLock = Entry.createElement('li').addClass('objectInfo_unlock');
      if (this.getLock()) {
        objectInfoLock.addClass('objectInfo_lock');
      }
      if (Entry.objectEditable) {
        objectInfoVisible.bindOnClick(function () {
          if (Entry.engine.isState('run')) {
            return;
          }
          var entity = _this9.entity;
          var visible = entity.setVisible(!entity.getVisible());
          if (visible) {
            objectInfoVisible.removeClass('objectInfo_unvisible');
          } else {
            objectInfoVisible.addClass('objectInfo_unvisible');
          }
        });
        objectInfoLock.bindOnClick(function () {
          if (Entry.engine.isState('run')) {
            return;
          }
          if (_this9.setLock(!_this9.getLock())) {
            objectInfoLock.addClass('objectInfo_lock');
          } else {
            objectInfoLock.removeClass('objectInfo_lock');
          }
          _this9.updateInputViews(_this9.getLock());
        });
      }
      objectInfoView.appendChild(objectInfoVisible);
      objectInfoView.appendChild(objectInfoLock);
      return objectInfoView;
    }
  }, {
    key: "createObjectView",
    value: function createObjectView(objectId, exceptionsForMouseDown) {
      var _this0 = this;
      var objectView = Entry.createElement('li', objectId).addClass('entryContainerListElementWorkspace');
      $(objectView).on('dragstart', function (e) {
        e.originalEvent.dataTransfer.setData('text', objectId);
      });
      var fragment = document.createDocumentFragment();
      fragment.appendChild(objectView);
      // generate context menu
      Entry.Utils.disableContextmenu(objectView);
      objectView.addEventListener('click', function (e) {
        var isFirstClick = !_.includes(_this0.view_.classList, 'selectedObject');
        if (isFirstClick && Entry.isMobile()) {
          e.preventDefault();
          document.activeElement.blur();
        }
        if (Entry.container.getObject(objectId) && !_.includes(exceptionsForMouseDown, e.target)) {
          Entry["do"]('selectObject', objectId);
        }
      });
      var longPressEvent = function longPressEvent(e) {
        var doc = $(document);
        var touchEvent = Entry.Utils.convertMouseEvent(e);
        var mouseDownCoordinate = {
          x: touchEvent.clientX,
          y: touchEvent.clientY
        };
        var longPressTimer = null;
        longPressTimer = setTimeout(function () {
          if (longPressTimer) {
            longPressTimer = null;
            _this0._rightClick(e);
          }
        }, 1000);
        doc.bind('mousemove.object touchmove.object', function (e) {
          var touchEvent = Entry.Utils.convertMouseEvent(e);
          var diff = Math.sqrt(Math.pow(touchEvent.pageX - mouseDownCoordinate.x, 2) + Math.pow(touchEvent.pageY - mouseDownCoordinate.y, 2));
          if (diff > 5 && longPressTimer) {
            clearTimeout(longPressTimer);
            longPressTimer = null;
          }
        });
        doc.bind('mouseup.object touchend.object', function (e) {
          e.stopPropagation();
          doc.unbind('.object');
          if (longPressTimer) {
            clearTimeout(longPressTimer);
            longPressTimer = null;
          }
        });
      };
      objectView.addEventListener('mousedown', function (e) {
        if (Entry.Utils.isRightButton(e)) {
          e.stopPropagation();
          _this0._rightClick(e);
        }
        if (Entry.isMobile()) {
          e.stopPropagation();
          longPressEvent(e);
        }
      });
      objectView.addEventListener('touchstart', function (e) {
        e.eventFromEntryObject = true;
        Entry.documentMousedown.notify(e);
        longPressEvent(e);
      });
      return objectView;
    }
  }, {
    key: "_getRotateView",
    value: function _getRotateView() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'free';
      if (type === 'free') {
        return this.rotateModeAView_;
      } else if (type === 'none') {
        return this.rotateModeCView_;
      } else {
        return this.rotateModeBView_;
      }
    }
  }, {
    key: "getIndex",
    value: function getIndex() {
      return Entry.container.getObjectIndex(this.id);
    }
  }, {
    key: "_whenRotateEditable",
    value: function _whenRotateEditable(func, obj) {
      return Entry.Utils.when(function () {
        return !(Entry.engine.isState('run') || obj.getLock());
      }, func);
    }
  }]);
}();